import { usePublicationByZoneLibbyCall } from './PublicationByZoneBusinessGenerated';
import { Publication } from '../../models';

export const usePublicationByZone = (zone: string) => usePublicationByZoneLibbyCall<Publication[]>({ methodName: 'getByZone', params: [zone] });
